import React, { useEffect, useState } from "react"
import { Button, Table2, Label } from "components";
import { Plus, Trash, Edit } from "../../../../../../layouts/dashboard/sidebar/icons/icons/icons";
import useTheme from "../../../../../../../../hooks/useTheme";
import "../modals.scss";


export const WebhookTable = ({ data, edit, remove, skipButtons }) => {

	if(skipButtons && !data.length) {
		return null
	}

	const columns = [{
		accessor: "webhook",
		Header: "URL",
		Cell: ({ row }) => row.original,
	}, {
		accessor: "options",
		Header: "",
		disableSortBy: true,
		Cell: ({ row }) => skipButtons ? null : (
			<div className="widget-table-options">
				<Button onClick={() => edit(row.index)} size="large" square variant="secondary" className="mr-3">
					<Edit />
				</Button>
				<Button onClick={() => remove(row.index)} size="large" square variant="warning">
					<Trash />
				</Button>
			</div>
		)
	}];


	if(skipButtons) {
		columns.pop()
	}

	if(!data.length) {
		return null
	}

	return <div className="widget-modal-table">
		<Table2 data={data} columns={columns} notFound="No webhook URLs" />
	</div>;
}


const WebhookForm = ({ data, setData, cancel, update, active }) => {

	if(active !== "" && !active) {
		return null
	}

	return <div className="custom-widget">

		<div className="custom-widget-body">

			<div className="w-100">
				<label className="paylixecommerce-label" htmlFor="webhook">URL</label>
				<input className="paylixecommerce-input" value={data} placeholder="https://www.example.com/endpoint" onChange={(e) => setData(e.target.value)}/>
			</div>

		</div>

		<div className="custom-widget-footer">
			<Button size="large" variant="secondary" className="mr-3" onClick={cancel}>
				Cancel
			</Button>
			<Button size="large" onClick={update} disabled={!data ? "disabled" : ""}>
				Save
			</Button>
		</div>

	</div>
}


export default ({ setModal, modal, fields, updateFields, skipButtons }) => {

	const [currentIndex, setCurrentIndex] = useState(null);
	const [data, setData] = useState(null);
	const isDark = useTheme();

	useEffect(() => {
		if(currentIndex) {
			let field = fields[currentIndex] ? fields[currentIndex] : "";
			setData(field);
		}
	}, [currentIndex]);


	const addField = (index) => {
		setCurrentIndex(index ? index : true);
	};

	const updateField = () => {

		if(fields[currentIndex]) {
			fields[currentIndex] = data;
			updateFields([
				...fields
			]);
		} else {
			updateFields([
				...fields,
				data
			]);
		}

		setCurrentIndex(null);
		setData(null);
		setModal(null);
	}

	const cancelEdit = () => {
		setCurrentIndex(null);
		setData(null);
		setModal(null);
	}

	useEffect(() => {
		return () => {
			setCurrentIndex(null)
		}
	}, [])

	const editField = (index) => {
		setCurrentIndex(index);
		setData(fields[index]);
		setModal(fields[index]);
	}

	const removeField = (index) => {

		if(fields[index]) {

			let updated = Object.assign([], fields)
			updated.splice(index, 1)
			updateFields([
				...updated
			]);

		}

		setCurrentIndex(null);
	}

	return <div className="widget-modal">

		{skipButtons ? null : <Label label="Webhook URLs" tooltip="Set your webhook URLs to receive updates on the product and product's orders status" name="webhook" />}

		<WebhookTable data={fields} edit={editField} remove={removeField} />

		{modal ? <WebhookForm update={updateField} cancel={cancelEdit} setData={setData} data={data} active={modal} /> : <Button className="w-100" size="large" variant={isDark ? "primary" : "secondary"} iconName="plus" iconPosition="left" onClick={() => setModal(true)}>Add Webhook</Button>}
	</div>

}
